<!-- views/admin/children/PlayerWayOut.vue -->
<template>
  <div class="player-way-out-config">
    <!-- 头部操作栏 -->
    <div class="header">
      <h1>选手出路配置</h1>
      <div class="header-actions">
        <button class="btn save-btn" @click="saveConfig" :disabled="isSaving">
          {{ isSaving ? '保存中...' : '保存配置' }}
        </button>
      </div>
    </div>

    <!-- 配置编辑区域 -->
    <div class="config-editor">
      <!-- 板块基础信息 -->
      <div class="config-section">
        <div class="section-header">
          <h2>板块基础信息</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>板块标题</label>
            <input type="text" v-model="sectionData.title" placeholder="请输入板块标题">
          </div>
          <div class="form-group">
            <label>板块描述</label>
            <textarea v-model="sectionData.desc" placeholder="请输入板块描述"></textarea>
          </div>
        </div>
      </div>

      <div class="config-section">
        <div class="section-header">
          <h2>图片配置</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>图片链接</label>
            <input type="text" v-model="sectionData.data.bannerImg" placeholder="请输入Banner图片链接">
          </div>
          <div class="form-group">
            <label>Banner背景图</label>
            <div class="image-upload">
              <img v-if="sectionData.data.bannerImg" :src="sectionData.data.bannerImg" class="preview-img">
              <div v-else class="upload-placeholder">
                <span>点击上传图片</span>
              </div>
              <input type="file" @change="uploadBannerImage" accept="image/*" hidden ref="bannerUpload">
              <button class="upload-btn" @click="$refs.bannerUpload.click()">上传图片</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 赛事播放平台配置 -->
      <div class="config-section">
        <div class="section-header">
          <h2>赛事播放平台配置</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>标题</label>
            <input type="text" v-model="sectionData.data.broadcastPlatforms.title" placeholder="请输入标题">
          </div>

          <div class="form-group">
            <label>平台列表</label>
            <div class="platforms-container">
              <!-- 平台列表横向排列 -->
              <div class="platform-list-horizontal">
                <div
                    v-for="(platform, index) in sectionData.data.broadcastPlatforms.lists.flat()"
                    :key="index"
                    class="platform-item"
                >
                  <input
                      type="text"
                      v-model="flatPlatformList[index]"
                      placeholder="请输入平台名称"
                  >
                  <button
                      class="remove-platform-btn"
                      @click="removePlatform(index)"
                  >
                    删除
                  </button>
                </div>
                <button class="add-platform-btn" @click="addPlatform">添加平台</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 发展路径配置 -->
      <div class="config-section">
        <div class="section-header">
          <h2>发展路径配置</h2>
        </div>
        <div class="section-content">
          <div class="path-items-horizontal">
            <div
                v-for="(item, index) in sectionData.data.pathItems"
                :key="index"
                class="path-item"
            >
              <div class="path-header">
                <h3>路径 {{ index + 1 }}</h3>
                <button class="remove-btn" @click="removePathItem(index)">删除</button>
              </div>

              <div class="form-group">
                <label>标题</label>
                <input type="text" v-model="item.title" placeholder="请输入标题">
              </div>

              <div class="form-group">
                <label>描述</label>
                <textarea v-model="item.desc" placeholder="请输入描述"></textarea>
              </div>
            </div>

            <button class="add-path-btn" @click="addPathItem">添加路径</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { getBanner, updateBannerApi ,uploadFileApi} from '@/api/website'

// 板块数据
const sectionData = ref({
  id: "path",
  title: "",
  desc: "",
  component: "PathList",
  data: {
    bannerImg: "",
    broadcastPlatforms: {
      title: "",
      lists: [
        ["梅州县电视台", "梅州市电视台", "广东省电视台", "湖南省芒果台", "中央电视台"],
        ["腾讯官方号", "百度官方号", "爱奇艺官方号", "微博官方号", "星途杯公众号"],
        ["抖音官方号", "快手官方号", "小红书官方号", "娱乐世界平台", "客都官方平台"]
      ]
    },
    pathItems: [
      {
        title: "平台身份",
        desc: "报名参赛自动录入娱乐世界\n未来之星艺术人才储备资源"
      },
      {
        title: "展示窗口",
        desc: "未来之星随时可以发布动态\n娱乐世界内容创作也可发布"
      },
      {
        title: "作品参与",
        desc: "获奖选手直接参与短剧拍摄\n潜力选手集训参与短剧拍摄"
      },
      {
        title: "更大舞台",
        desc: "优秀人才娱乐世界签约孵化\n全面输送剧组综艺选秀培养"
      }
    ]
  }
})

const isSaving = ref(false)
const allConfig = ref({}) // 保存完整的配置数据

// 计算属性：将嵌套数组扁平化以便于编辑
const flatPlatformList = computed({
  get() {
    return sectionData.value.data.broadcastPlatforms.lists.flat();
  },
  set(value) {
    // 这里不需要实现setter，因为我们会直接修改原始数组
  }
});
// 上传Banner图片
const uploadBannerImage = async (event) => {
  const file = event.target.files[0]
  console.log('file:', file)
  if (!file) return
  try {
    const formData = new FormData()
    formData.append('multipartFile', file)
    const response = await uploadFileApi(formData)
    console.log('response:', response.data.data)
    // 根据实际API响应结构调整
    if (response.data && response.data.data) {
      sectionData.value.data.bannerImg = response.data.data
    }
  } catch (error) {
    console.error('上传图片失败:', error)
    alert('上传失败，请重试')
  }
}
// 加载配置
const loadConfig = async () => {
  try {
    const response = await getBanner({"adminId":1})
    if (response.data) {
      allConfig.value = response.data.data

      // 查找path板块数据
      const pathSection = allConfig.value.data.sections.find(section => section.id === "path")
      if (pathSection) {
        sectionData.value = {
          ...sectionData.value,
          ...pathSection
        }
      }
    }
  } catch (error) {
    console.error('加载配置失败:', error)
    alert('加载配置失败，请重试')
  }
}

// 保存配置
const saveConfig = async () => {
  try {
    isSaving.value = true

    // 更新完整配置中的path板块数据
    const sectionIndex = allConfig.value.data.sections.findIndex(section => section.id === "path")
    if (sectionIndex !== -1) {
      allConfig.value.data.sections[sectionIndex] = {...sectionData.value}
    }
    // 查找并更新导航栏中指向#intro的链接标题
    const navSection = allConfig.value.data.sections.find(section => section.id === "nav")
    if (navSection) {
      const introNavItem = navSection.data.find(item => item.link === "#path")
      if (introNavItem) {
        introNavItem.label = sectionData.value.title
      }
    }
    await updateBannerApi(allConfig.value)
    alert('保存成功！')
  } catch (error) {
    console.error('保存配置失败:', error)
    alert('保存失败，请重试')
  } finally {
    isSaving.value = false
  }
}

// 添加平台
const addPlatform = () => {
  // 将新平台添加到第一个子数组中
  if (sectionData.value.data.broadcastPlatforms.lists.length === 0) {
    sectionData.value.data.broadcastPlatforms.lists.push([""]);
  } else {
    sectionData.value.data.broadcastPlatforms.lists[0].push("");
  }
}

// 删除平台
const removePlatform = (index) => {
  if (confirm('确定要删除这个平台吗？')) {
    // 计算扁平化后的索引在原始嵌套数组中的位置
    let currentIndex = 0;
    let found = false;

    for (let i = 0; i < sectionData.value.data.broadcastPlatforms.lists.length; i++) {
      const list = sectionData.value.data.broadcastPlatforms.lists[i];
      if (index < currentIndex + list.length) {
        const innerIndex = index - currentIndex;
        list.splice(innerIndex, 1);
        found = true;
        break;
      }
      currentIndex += list.length;
    }

    // 如果删除后某个子数组为空，则移除该子数组（保留至少一个）
    if (found) {
      for (let i = sectionData.value.data.broadcastPlatforms.lists.length - 1; i >= 0; i--) {
        if (sectionData.value.data.broadcastPlatforms.lists[i].length === 0 &&
            sectionData.value.data.broadcastPlatforms.lists.length > 1) {
          sectionData.value.data.broadcastPlatforms.lists.splice(i, 1);
        }
      }
    }
  }
}

// 添加路径项
const addPathItem = () => {
  sectionData.value.data.pathItems.push({
    title: "",
    desc: ""
  })
}

// 删除路径项
const removePathItem = (index) => {
  if (confirm('确定要删除这个路径吗？')) {
    sectionData.value.data.pathItems.splice(index, 1)
  }
}

// 初始化加载配置
onMounted(() => {
  loadConfig()
})
</script>

<style scoped lang="scss">
.player-way-out-config {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

.header {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;

  h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
  }
}

.header-actions {
  display: flex;
  gap: 12px;

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .save-btn {
    background-color: #E6398B;
    color: white;

    &:hover:not(:disabled) {
      background-color: #d4287a;
    }
  }
}

.config-editor {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.config-section {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  background-color: #fafafa;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
}

.section-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  input[type="text"],
  input[type="color"],
  select,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s;

    &:focus {
      border-color: #1890ff;
      outline: none;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
    }
  }

  textarea {
    min-height: 80px;
    resize: vertical;
  }
}

.banner-preview {
  max-width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.platforms-container {
  .platform-list-horizontal {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;

    .platform-item {
      display: flex;
      gap: 10px;
      align-items: center;

      input {
        width: 150px;
      }

      .remove-platform-btn {
        padding: 6px 10px;
        background-color: #ff4d4f;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;

        &:hover {
          background-color: #d9363e;
        }
      }
    }

    .add-platform-btn {
      padding: 8px 16px;
      background-color: #1890ff;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      height: fit-content;
      align-self: center;

      &:hover {
        background-color: #40a9ff;
      }
    }
  }
}

.path-item {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.path-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
  }

  .remove-btn {
    padding: 4px 12px;
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;

    &:hover {
      background-color: #d9363e;
    }
  }
}

.add-path-btn {
  width: 100%;
  padding: 12px;
  border: 2px dashed #ddd;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;
    background-color: rgba(24, 144, 255, 0.05);
  }
}
.path-items-horizontal {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
}

.path-items-horizontal .path-item {
  flex: 1;
  min-width: 300px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 0;
}

.path-items-horizontal .path-item .path-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.path-items-horizontal .path-item .path-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.path-items-horizontal .path-item .path-header .remove-btn {
  padding: 4px 12px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.path-items-horizontal .path-item .path-header .remove-btn:hover {
  background-color: #d9363e;
}

.path-items-horizontal .path-item .form-group {
  margin-bottom: 15px;
}

.path-items-horizontal .path-item .form-group:last-child {
  margin-bottom: 0;
}

.path-items-horizontal .path-item .form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.path-items-horizontal .path-item .form-group input[type="text"],
.path-items-horizontal .path-item .form-group textarea {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
}

.path-items-horizontal .path-item .form-group textarea {
  min-height: 60px;
}

.path-items-horizontal .add-path-btn {
  align-self: flex-start;
  padding: 10px 20px;
  border: 2px dashed #ddd;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s;
  height: fit-content;
  margin-top: 30px;
}

.path-items-horizontal .add-path-btn:hover {
  border-color: #1890ff;
  color: #1890ff;
  background-color: rgba(24, 144, 255, 0.05);
}

.image-upload {
  display: flex;
  align-items: center;
  gap: 16px;

  .preview-img {
    width: 200px;
    height: 100px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .upload-placeholder {
    width: 200px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ddd;
    border-radius: 4px;
    color: #999;
    font-size: 14px;
  }

  .upload-btn {
    padding: 8px 16px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background-color: #e8e8e8;
    }
  }
}
</style>
